import request from './request';

// 不回店统计-图表
export function getNotBack(params) {
    return request('/stat/clue/not-back/view', {
        method: 'POST',
        params,
    });
}

// 不回店统计-列表
export function getNotBackList(params) {
    return request('/stat/clue/not-back/list', {
        method: 'POST',
        params,
    });
}

// 不回店车辆去向查询
export function getNotBackVehicle(params) {
    return request('/stat/clue/not-back/vehicle', {
        method: 'POST',
        params,
        timeout: 120 * 1000,
    });
}
